import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, mergeProps as _mergeProps, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa236576"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view" }

import { computed } from 'vue';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { ScForm } from '@/models/ScForm';
import { AreaFieldType } from '@/components/business/crud/interface/FieldType';
import { getArea, getOptions } from '@/components/business/crud/widgets/impl/area';
import AreaTable from '@/components/business/crud/widgets/impl/AreaTable.vue';
import { ShowSearchType } from 'ant-design-vue/es/vc-cascader';


export default /*#__PURE__*/_defineComponent({
  __name: 'AreaForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const filter: ShowSearchType['filter'] = (inputValue, path) => {
  return path.some(
    (option) =>
      option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
  );
};

const props = __props;
const data = ScForm.useFormData();

const value = computed({
  get() {
    return data.value[props.propName] ? getArea(data.value[props.propName]).ids : undefined;
  },
  set(val?: string[]) {
    data.value[props.propName] = val ? val[val.length - 1] : undefined;
  },
});

return (_ctx: any,_cache: any) => {
  const _component_a_cascader = _resolveComponent("a-cascader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_a_cascader, {
      value: value.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      options: _unref(getOptions)(_ctx.widget.level),
      placeholder: '请选择' + _ctx.info.title,
      "change-on-select": !_ctx.widget.level,
      "show-search": { filter: filter },
      style: {"width":"100%"}
    }, null, 8, ["value", "options", "placeholder", "change-on-select", "show-search"]), [
      [_vShow, _ctx.info.status === 'edit']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(AreaTable, _mergeProps({ data: _unref(data) }, _ctx.$props), null, 16, ["data"])
    ], 512), [
      [_vShow, _ctx.info.status === 'show']
    ])
  ], 64))
}
}

})